<template>
  <div class="scene-list-wrapper">
    <van-pull-refresh v-model="isLoading" @refresh="pullDownRefresh">
      <img slot="loading" :src="loadingSrc" class="boms-loading-sm">
      <img slot="normal" :src="loadingSrc" class="boms-loading-sm">
      <img slot="pulling" :src="loadingSrc" class="boms-loading-sm">
      <img slot="loosing" :src="loadingSrc" class="boms-loading-sm">
      <van-list
        v-model="pullUpLoading"
        :finished="isMaxData"
        :immediate-check="false"
        @load="pullUpLoadData"
      >
        <list-of-route
          v-for="item of routeListData"
          :key="item.id"
          :item="item"
          @click.native="redirectToRouteDetail(item.id)"
        ></list-of-route>
      </van-list>
    </van-pull-refresh>
    <page-guide></page-guide>
  </div>
</template>

<script>
import ListOfRoute from "@/components/ListOfRoute";
import PageGuide from "@/components/common/PageGuide";
export default {
  name: "routeList",
  components: { ListOfRoute,PageGuide },
  props: {
    // layouts: String,
    // layoutType: String,
  },
  data() {
    return {
      isLoading: false,
      pullUpLoading: false,
      isMaxData: false,
      currentPage: 0,
      routeListData: [],
      numberInEachPage: 10,
      isWXSharePage: true,
      loadingSrc: "",
      token: sessionStorage.getItem("token") || ""
    };
  },
  computed: {},
  activated() {
        this.isWXSharePage = true;
        this.pullDownRefresh();
  },
  deactivated() {
    this.isWXSharePage = false;
  },
  watch: {},
  created() {
    this.isWXSharePage = true;
    this.pullDownRefresh();
  },
  mounted() {
    this.loadingSrc = API.ossUrl + "yyq/loading.gif";
  },
  destroyed() {},
  methods: {
    getRouteDataFromPage(number = 1) {
      return this.$axios.get(
        `${API.route.list}/${number}/${this.numberInEachPage}?token=${
          sessionStorage.token
        }`
      );
    },
    //下拉刷新
    pullDownRefresh() {
      let vm = this;
      this.getRouteDataFromPage(1)
        .then(({ data }) => {
          if (data.code == 200) {
            let res = data.data;
            vm.routeListData = res.list;
            vm.isLoading = false;
            vm.currentPage = 1;
            vm.isMaxData = res.pageNo >= res.pageCount;
            vm.$nextTick(vm.hiddenTag);
            //初始化微信分享
            if (
              this.isWXSharePage &&
              sessionStorage.getItem("title") !==
                `${API.projectName}-${vm.$route.meta.title}`
            ) {
              this.isWXSharePage = false;
              window.global.getConfig({
                title: `${API.projectName}-${vm.$route.meta.title}`,
                link: `${window.location.origin}?shareto=${vm.$route.name}`,
                imgUrl: `${
                  vm.routeListData[0]
                    ? vm.routeListData[0].img +
                      "?x-oss-process=image/resize,m_fill,h_256,w_256"
                    : ""
                }`,
                desc: ``
              });
            }
          } else {
            vm.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    //上拉加载
    pullUpLoadData(number) {
      let vm = this;
      if (vm.currentPage == 0) return (vm.pullUpLoading = false);
      this.getRouteDataFromPage(vm.currentPage + 1)
        .then(({ data }) => {
          if (data.code == 200) {
            let res = data.data;
            vm.routeListData = vm.routeListData.concat(res.list);
            vm.pullUpLoading = false;
            vm.currentPage = Number(res.pageNo);
            vm.isMaxData = res.pageNo >= res.pageCount;
            vm.$nextTick(vm.hiddenTag);
          } else {
            vm.$toast(data.msg);
          }
        })
        .catch(err => console.log(err));
    },
    redirectToRouteDetail(routeId) {
      this.$router.push({
        name: "routeDetail",
        params: { routeId }
      });
    },
    hiddenTag() {
      let tagArray = [...document.querySelectorAll(".tag")];
      let cw = document.body.clientWidth - 16;
      tagArray.forEach(element => {
        if (element.getBoundingClientRect().right > cw) {
          element.style.visibility = "hidden";
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.scene-list-wrapper {
  padding: 0.64rem 0.506667rem 0;
  display: flex;
  min-height: 100%;
  .van-pull-refresh {
    width: 100%;
    flex: 1;
  }
}
</style>

